import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { RadioButton, Row } from '../../atoms';
import { theme } from '@xbto/design-system';
export function RadioGroup({ items, onChange, value, disabled, }) {
    return (_jsx(Row.L, { style: $.container, children: items.map(item => (_jsx(RadioButton, { active: item.value === value, small: true, title: item.label, value: item.value, onPress: onChange, disabled: disabled }, item.value))) }));
}
const $ = StyleSheet.create({
    container: {
        gap: theme.spacing['1'],
    },
});
